import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Form} from 'react-bootstrap';
import PreviewFileUpload from '@app/components/input-file/PreviewFileUpload';
import {acceptImage} from '@app/utils/define';
import path from 'path';
import mime from 'mime-types';
import {DeleteSingle} from '@app/utils/httpProvider';
import {FILE_MANAGER_API} from '@app/utils/apiUrl';

const InputFile = (props) => {
    const {values, multiple, accept, enableReinitialize, onChange, labelImage, isDocument} = props;
    const [files, setFiles] = useState([]);
    const inputUpload = useRef();
    useEffect(() => {
        if (
            (values && values.length > 0 && files.length === 0) ||
            enableReinitialize
        ) {
            const listFile = [];
            for (let index = 0; index < values.length; index++) {
                const fileUrl = values[index];
                const filename = path.basename(fileUrl);
                listFile.push({
                    name: filename,
                    url: fileUrl,
                    type: mime.lookup(filename)
                });
            }
            setFiles(listFile);
        }
    }, [values]);

    useEffect(()=>{
        return(()=>{
            
        })
    })

    const handleInputChange = (e) => {
        const listFile = multiple ? [...files] : [];
        for (let i = 0; i < e.target.files.length; i++) {
            listFile.push(e.target.files[i]);
        }
        inputUpload.current.value = '';
        setFiles(listFile);
    };

    //
    const handleUploaded = (file, index) => {
        files[index] = file;
        // setFiles(files);
        onChange(files);
    };

    const handleRemoveFile = async (index) => {
        const fileToRemove = files[index];
        const listFile = files.filter((_, i) => i !== index);
        
        // Cập nhật UI ngay lập tức
        setFiles(listFile);
        onChange(listFile);

        // Nếu file đã có URL (đã được upload thành công lên server), thực hiện xóa vật lý ở background
        if (fileToRemove && fileToRemove.url) {
            try {
                // Lấy relative path từ URL (bỏ BaseGatewayImage nếu có)
                let filePath = fileToRemove.filePath || (fileToRemove.url ? fileToRemove.url : '');
                
                // Nếu là URL tuyệt đối, chỉ lấy phần path
                if (typeof filePath === 'string' && filePath.startsWith('http')) {
                    try {
                        const url = new URL(filePath);
                        filePath = url.pathname;
                    } catch (e) {
                        // ignore
                    }
                }
                
                // Call API xóa vật lý
                DeleteSingle(`${FILE_MANAGER_API.DELETE}/DeleteByPath`, null, { filePath: filePath });
            } catch (error) {
                console.error("Lỗi khi xóa file vật lý:", error);
            }
        }
    };
    return (
        <>
            <span
                className="btn btn-success col fileinput-button dz-clickable col-sm-3"
                onClick={() => inputUpload.current.click()}
                role="presentation"
                style={{display: multiple ? 'block' : 'none'}}
            >
                <i className="fas fa-plus" />
                <span> Chọn file</span>
            </span>

            <Form.Control
                type="file"
                multiple={multiple}
                hidden
                accept={multiple ? accept : acceptImage}
                ref={inputUpload}
                onChange={(e) => handleInputChange(e)}
            />
            {!multiple ? (
                <div className="img_add">
                    <div className="rowImage">
                        {files[0] && files[0].url !== '' && (
                            <PreviewFileUpload
                                fileView={files[0]}
                                isThumbnail="true"
                                uploaded={(data) => handleUploaded(data, 0)}
                                actionRemove={() => handleRemoveFile(0)}
                            />
                        )}
                    </div>
                    {files.length === 0 && (
                        <div
                            className="img_add_placeholder rounded"
                            role="presentation"
                            onClick={() => inputUpload.current.click()}
                        >
                            <span>{labelImage ? labelImage : 'Chọn ảnh upload'}</span>
                        </div>
                    )}
                </div>
            ) : (
                files.map((file, index) => (
                    <div
                        className="row m-1"
                        key={file.url ? file.url : file.lastModified}
                    >
                        <PreviewFileUpload
                            fileView={file}
                            isDocument={isDocument}
                            uploaded={(data) => handleUploaded(data, index)}
                            actionRemove={() => handleRemoveFile(index)}
                        />
                    </div>
                ))
            )}
        </>
    );
};

InputFile.propTypes = {
    multiple: PropTypes.bool,
    enableReinitialize: PropTypes.bool,
    accept: PropTypes.string,
    onChange: PropTypes.func,
    values: PropTypes.arrayOf(PropTypes.string),
    isDocument: PropTypes.bool
};

InputFile.defaultProps = {
    multiple: false,
    enableReinitialize: false,
    accept: 'application/*,image/png,image/jpg,image/jpeg',
    onChange: () => {},
    values: []
};

export default InputFile;
